import React from 'react';
import { LoadingButton } from '@mui/lab';

const WorkflowButtonPrimary = ({
  variant = 'contained',
  text,
  'data-test-id': dataTestId,
  ...rest
}) => {

  return (
    <LoadingButton
      variant={variant}
      data-test-id={dataTestId}
      sx={{
        minHeight: '27px',
        height: '27px',
        textTransform: 'none',
      }}
      {...rest}
    >
      {text}
    </LoadingButton>
  );
};

export default WorkflowButtonPrimary;
